// Handles Add To Cart from product card
// Ensures only the button triggers add, prevents card redirect, opens cart drawer

document.addEventListener('DOMContentLoaded', function() {
  // Initialize card add-to-cart buttons
  initCardAddToCartButtons();
  
  // Handle dynamic content loading
  document.addEventListener('shopify:section:load', initCardAddToCartButtons);
});

// Helper functions for card interaction
function getCardAnchor(btn) {
  // Look for nearest .card or .product-card-wrapper, then anchor inside
  let card = btn.closest('.card, .product-card-wrapper, .card-product');
  if (!card) return null;
  // Find anchor inside card, prefer a.card or .full-unstyled-link
  return card.querySelector('a.card__heading, a.full-unstyled-link, a');
}

function disableAnchor(anchor) {
  if (!anchor) return;
  // Store original href and add class
  if (!anchor.hasAttribute('data-original-href') && anchor.getAttribute('href')) {
    anchor.setAttribute('data-original-href', anchor.getAttribute('href'));
    anchor.removeAttribute('href'); // Actually remove the href
  }
  anchor.classList.add('card-atc-disable-link');
  anchor.style.pointerEvents = 'none';
}

function enableAnchor(anchor) {
  if (!anchor) return;
  // Restore original href
  if (anchor.hasAttribute('data-original-href')) {
    anchor.setAttribute('href', anchor.getAttribute('data-original-href'));
    anchor.removeAttribute('data-original-href');
  }
  anchor.classList.remove('card-atc-disable-link');
  anchor.style.pointerEvents = '';
}

function initCardAddToCartButtons() {
  // Find all card__add-to-cart-btn buttons
  const addToCartButtons = document.querySelectorAll('.card__add-to-cart-btn');
  
  // For each button, apply necessary styles and event handling
  addToCartButtons.forEach(button => {
    // Store original text
    if (!button.hasAttribute('data-original-text')) {
      button.setAttribute('data-original-text', button.textContent);
    }
    
    // Apply high z-index and relative positioning for proper stacking
    button.style.position = 'relative';
    button.style.zIndex = '9999';
    
    // Make the button container also have high z-index
    const buttonContainer = button.closest('.card__add-to-cart');
    if (buttonContainer) {
      buttonContainer.style.position = 'relative';
      buttonContainer.style.zIndex = '9999';
    }
  });
  
  // Set up event listeners once
  setupEventListeners();
}

function setupEventListeners() {
  // First remove any existing listeners to prevent duplicates
  document.body.removeEventListener('click', handleCardAddToCartClick, true);
  document.body.removeEventListener('mousedown', preventCardLinkPropagation, true);
  document.body.removeEventListener('touchstart', preventCardLinkPropagation, true);
  document.body.removeEventListener('mouseenter', handleButtonMouseEnter, true);
  document.body.removeEventListener('mouseleave', handleButtonMouseLeave, true);
  document.body.removeEventListener('focusin', handleButtonFocusIn);
  document.body.removeEventListener('focusout', handleButtonFocusOut);
  
  // Then add them back WITH CAPTURE phase (true) to ensure they run before link clicks
  document.body.addEventListener('click', handleCardAddToCartClick, true);
  document.body.addEventListener('mousedown', preventCardLinkPropagation, true);
  document.body.addEventListener('touchstart', preventCardLinkPropagation, true);
  document.body.addEventListener('mouseenter', handleButtonMouseEnter, true);
  document.body.addEventListener('mouseleave', handleButtonMouseLeave, true);
  document.body.addEventListener('focusin', handleButtonFocusIn, true);
  document.body.addEventListener('focusout', handleButtonFocusOut, true);
}

function handleCardAddToCartClick(e) {
  // Use closest to find the button, even if a child element was clicked
  const button = e.target.closest('.card__add-to-cart-btn');
  if (!button) return;
  
  // Stop event propagation to prevent card link clicking
  e.stopPropagation();
  e.preventDefault();
  e.stopImmediatePropagation();
  
  // Get variant ID
  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;
  
  // Disable any card links to prevent navigation
  const card = button.closest('.card-product, .card, .product-card-wrapper');
  if (card) {
    const cardLinks = card.querySelectorAll('a[href]');
    cardLinks.forEach(link => disableAnchor(link));
  }
  
  // Disable button and show loading state
  button.disabled = true;
  button.classList.add('loading');
  
  // Add to cart via fetch
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Show success feedback
    button.textContent = window.theme.strings.addedToCart || 'Added!';
    
    // Function to update cart count if needed
    function updateCartCount() {
      // If there's a cart count element, update it
      const cartCount = document.querySelector('.cart-count-bubble');
      if (cartCount) {
        // Get updated cart count from the server
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(cart => {
            const count = cart.item_count;
            if (count > 0) {
              cartCount.textContent = count;
              cartCount.classList.remove('hidden');
            }
          })
          .catch(e => console.error('Error updating cart count:', e));
      }
    }
    
    // Update the cart count
    updateCartCount();
    
    // Open the cart drawer using multiple approaches for maximum compatibility
    setTimeout(() => {
      // First try the global helper
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer(button);
      } 
      // Then try our local helper
      else if (typeof forceCartDrawerOpen === 'function') {
        forceCartDrawerOpen(button);
      }
      // Last resort: manually activate the drawer
      else {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            // Try setting the active element first if available
            if (typeof cartDrawer.setActiveElement === 'function') {
              cartDrawer.setActiveElement(button);
            }
            cartDrawer.open(button);
          } else {
            // Fallback to manually adding classes
            cartDrawer.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
            
            // Also modify the transform property directly if possible
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) {
              drawerInner.style.transform = 'translateX(0)';
            }
          }
        }
        
        // Also dispatch a custom event that other scripts might listen for
        document.dispatchEvent(new CustomEvent('cart:refresh', { 
          detail: { 
            trigger: button
          }
        }));
      }
    }, 300);
    
    // Reset button state after delay
    setTimeout(() => {
      button.disabled = false;
      button.classList.remove('loading');
      button.textContent = button.getAttribute('data-original-text') || window.theme.strings.addToCart || 'Add to Cart';
      
      // Re-enable card links after operation is complete
      if (card) {
        const cardLinks = card.querySelectorAll('a.card-atc-disable-link');
        cardLinks.forEach(link => enableAnchor(link));
      }
    }, 1000);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    
    // Show error state
    button.textContent = window.theme.strings.addError || 'Error';
    
    // Reset button state
    setTimeout(() => {
      button.disabled = false;
      button.classList.remove('loading');
      button.textContent = button.getAttribute('data-original-text') || window.theme.strings.addToCart || 'Add to Cart';
      
      // Re-enable card links after operation is complete
      if (card) {
        const cardLinks = card.querySelectorAll('a.card-atc-disable-link');
        cardLinks.forEach(link => enableAnchor(link));
      }
    }, 2000);
  });
  
  return false; // Prevent default behavior
}

function preventCardLinkPropagation(e) {
  // If click is on add-to-cart button or its container, prevent event bubbling
  const button = e.target.closest('.card__add-to-cart-btn');
  const container = e.target.closest('.card__add-to-cart');
  
  if (button || (container && e.target.closest('.card__add-to-cart'))) {
    e.stopPropagation();
    e.preventDefault();
    
    // If this is a button event, actually handle it
    if (button && e.type === 'click') {
      handleCardAddToCartClick(e);
    }
  }
}

function handleButtonMouseEnter(e) {
  const button = e.target.closest('.card__add-to-cart-btn');
  if (!button) return;
  
  // Find the card element (try multiple selectors for compatibility)
  const card = button.closest('.card-product, .card, .product-card-wrapper');
  if (!card) return;
  
  // Find all anchor links in the card and temporarily disable them
  const cardLinks = card.querySelectorAll('a[href]');
  cardLinks.forEach(link => {
    disableAnchor(link);
  });
  
  // Set a flag on the button to indicate it's being hovered
  button.setAttribute('data-hover', 'true');
}

function handleButtonMouseLeave(e) {
  const button = e.target.closest('.card__add-to-cart-btn');
  if (!button) return;
  
  // Check if we're still within the button or its container
  const relatedTarget = e.relatedTarget;
  if (button.contains(relatedTarget) || 
      (button.closest('.card__add-to-cart') && 
       button.closest('.card__add-to-cart').contains(relatedTarget))) {
    return;
  }
  
  // Only re-enable links if we're actually leaving the button area
  button.removeAttribute('data-hover');
  
  // Find the card element
  const card = button.closest('.card-product, .card, .product-card-wrapper');
  if (!card) return;
  
  // Don't restore links if any add-to-cart button in this card is still being hovered
  const otherHoveredButtons = card.querySelectorAll('.card__add-to-cart-btn[data-hover="true"]');
  if (otherHoveredButtons.length > 0) return;
  
  // Restore anchor links
  const cardLinks = card.querySelectorAll('a.card-atc-disable-link');
  cardLinks.forEach(link => {
    enableAnchor(link);
  });
}

function handleButtonFocusIn(e) {
  const button = e.target.closest('.card__add-to-cart-btn');
  if (!button) return;
  
  // Set focus flag
  button.setAttribute('data-focus', 'true');
  
  // Find the card element
  const card = button.closest('.card-product, .card, .product-card-wrapper');
  if (!card) return;
  
  // Disable all links in the card
  const cardLinks = card.querySelectorAll('a[href]');
  cardLinks.forEach(link => {
    disableAnchor(link);
  });
}

function handleButtonFocusOut(e) {
  const button = e.target.closest('.card__add-to-cart-btn');
  if (!button) return;
  
  // Remove focus flag
  button.removeAttribute('data-focus');
  
  // Find the card element
  const card = button.closest('.card-product, .card, .product-card-wrapper');
  if (!card) return;
  
  // Don't restore links if any add-to-cart button in this card is still focused or hovered
  const focusedButtons = card.querySelectorAll('.card__add-to-cart-btn[data-focus="true"]');
  const hoveredButtons = card.querySelectorAll('.card__add-to-cart-btn[data-hover="true"]');
  if (focusedButtons.length > 0 || hoveredButtons.length > 0) return;
  
  // Restore anchor links
  const cardLinks = card.querySelectorAll('a.card-atc-disable-link');
  cardLinks.forEach(link => {
    enableAnchor(link);
  });
}

// Add this function after the initCardAddToCartButtons function
function forceCartDrawerOpen(button) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return false;
  
  // Method 1: Using the native open method (preferred)
  if (typeof cartDrawer.open === 'function') {
    try {
      // Store a reference to button for drawer to use
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(button);
      }
      cartDrawer.open(button);
      return true;
    } catch (e) {
      console.error('Error opening cart drawer via open method:', e);
    }
  }
  
  // Method 2: Manual class manipulation
  try {
    setTimeout(() => {
      // Add the active and animate classes
      cartDrawer.classList.add('animate', 'active');
      
      // Set the active element if possible
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(button);
      }
      
      // Add the overflow-hidden class to the body to prevent scrolling
      document.body.classList.add('overflow-hidden');
      
      // Get the inner drawer element and ensure it's visible
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner) {
        drawerInner.style.transform = 'translateX(0)';
      }
      
      return true;
    }, 100);
  } catch (e) {
    console.error('Error opening cart drawer via class manipulation:', e);
    return false;
  }
  
  return false;
}
